module.exports = __webpack_public_path__ + "static/media/calendary.eb69fc19.svg";